import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { startSubscriptionNow } from "@/services/api/Stripe";
import { LockKey } from "@phosphor-icons/react";
import { useRouter } from "next/router";
import toast from "react-hot-toast";
import { useState } from "react";
import ModalActivateSubscription from "./ModalActivateSubscription";
import ModalFullSubscription from "./modal/ModalFullSubscription";

export default function Paywall({
  startup,
  title,
  description,
  children,
  redirectTo,
  buttonText,
  action,
  disabled = false,
  isOpenModal,
  setIsOpenModal,
  planSubscription,
}) {
  const router = useRouter();
  const currentPath = router.asPath;

  const [loadingStartSubsNow, setLoadingStartSubsNow] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = typeof setIsOpenModal === "function";
  const setOpen = isControlled ? setIsOpenModal : setInternalOpen;
  const dialogOpen = loadingStartSubsNow
    ? true
    : isControlled
    ? isOpenModal
    : internalOpen;

  const isTrialing = planSubscription && planSubscription.status === "trialing";

  const handleButtonClick = () => {
    setOpen(false);

    if (isTrialing) {
      setOpen(false);
      setIsOpenConfirm(true);
    } else if (startup) {
      setLoadingStartSubsNow(true);
      setTimeout(() => {
        router.push("/pricing");
      }, 800);
    } else if (redirectTo) {
      setLoadingStartSubsNow(true);
      setTimeout(() => {
        router.push(redirectTo);
      }, 800);
    } else {
      if (typeof action === "function") {
        action();
      }
    }
  };

  return (
    <>
      <ModalActivateSubscription
        isOpen={isOpenConfirm}
        setIsOpen={setIsOpenConfirm}
        planSubscription={planSubscription}
      />
      <Dialog
        open={dialogOpen}
        onOpenChange={setOpen}
      >
        <DialogTrigger asChild>{children}</DialogTrigger>
        <DialogContent className='p-4 bg-white text-background'>
          <div className='text-center'>
            <LockKey className='mx-auto mb-3 text-5xl text-orange-1' />
            <p className='mb-2 text-2xl font-semibold leading-tight tracking-tight'>
              {title}
            </p>
            <p className='mb-5 text-sm opacity-70'>{description}</p>
            <Button
              disabled={disabled || loadingStartSubsNow}
              onClick={handleButtonClick}
              variant='secondary'
              className='w-full'
            >
              {buttonText
                ? buttonText
                : loadingStartSubsNow
                ? isTrialing
                  ? "Activating, Please Wait..."
                  : "Redirecting..."
                : isTrialing
                ? "Activate Full Subscription"
                : "Upgrade"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
